<template>
  <div class="container-tips container-general border-bottom pb-20">
    <section-title-after title="Come leggere le quotazioni"></section-title-after>
    <p>
      Le valutazioni delle automobili storiche si articolano in 7 fasce ("label"), ciascuna delle
      quali individua uno stato d'uso della vettura. Non tutti i modelli però presentano tutti i
      gradi di riferimento: per un numero esiguo di automobili di eccezionale rarità e valore
      infatti non è riscontrabile il valore C in quanto gli esemplari sono stati già restaurati e
      non utilizzati come fonte di ricambi. Il rapporto di valore tra una "label" e l'altra non è,
      come aweniva in precedenza, il risultato di una percentuale in più o in meno, ma è legato a
      una curva di svalutazione-rivalutazione che tiene conto di parametri specifici legati alla
      storia del modello, al suo successo commerciale (all'epoca e oggi), all'immagine del brand e
      di altre variabili.
    </p>
    <section-title-after
      title="Uso e validità delle quotazioni ruoteclassiche"
    ></section-title-after>
    <p>
      Le quotazioni Ruoteclassiche, sono il risultato di indagini di mercato sviluppate da
      Quattroruote Market Analysis in collaborazione con la redazione e un comitati di esperti.
      Indagini effettuate presso i principali stakeholder (case d'aste, club e registri di marca,
      case automobilistiche presenti con reparti heritage) producono le stime qui esposte e
      pubblicate sulle rivista Ruoteclassiche e Youngtimer, oltre ad essere fornite a tutti gli
      operatori professionali attraverso gli strumenti Quattroruote Professional.
    </p>
    <br />
    <p>
      Le quotazioni sono espresse in euro, e hanno validità per il mese solare nel quale è stata
      emesso l'attestato. Per ogni veicolo, le quotazioni si sviluppano su diversi livelli di valore
      identificati da specifiche "label" identificate dal lettere e simboli, per le auto sono sei o
      sette livelli (A+, A, AB, BA, B+, B, C), tre per le moto (A+, AB, B+) ed uno per i veicoli
      commerciali leggeri (AB). 1 livelli di valore, differenziano sostanzialmente le quotazioni
      Ruoteclassiche da quelle Quattroruote proprio nel metodo di attribuzione al singolo esemplare
      di veicolo la miglior stima.
    </p>
    <br />
    <p>
      Le quotazioni sono espresse in euro, e hanno validità per il mese solare nel quale è stata
      emesso l'attestato. Per ogni veicoli, le quotazioni si sviluppano su diversi livelli di
      valore, identificati da specifiche "label" identificate dal lettere e simboli, per le auto
      sono sei o sette livelli (A+, A, AB, BA, B+, B, C), tre per le moto (A+, AB, B+) ed uno per i
      veicoli commerciali leggeri (AB). I livelli di valore, differenziano sostanzialmente le
      quotazioni Ruoteclassiche da quelle Quattroruote proprio nel metodo di attribuzione al singolo
      esemplare di veicolo la miglior stima. Per le quotazioni Quattroruote si fa riferimento
      specificatamente all'anzianità e al chilometraggio del veicolo, fattori che nella stima del
      valore di un veicolo classico non hanno lo stesso interesse e applicabilità che hanno nella
      valutazione di un auto usata. Pertanto, per la corretta definizione del valore di un veicolo
      classico è indispensabile identificare a quale "label" di stato appartiene, affidandosi
      all'esperienza o alla stima di periti specializzati può aiutare ad identificarlo in maniera
      inequivocabile, nell'attestato si trovano tutti i livelli disponibili per lo specifico modello
      di veicolo. Rimandiamo alla pagine introduttive del servizio per ogni altro approfondimento.
    </p>
  </div>
</template>

<script>
import SectionTitleAfter from './SectionTitleAfter.vue';
export default {
  name: 'ClassicDisclaimer',
  components: {
    SectionTitleAfter,
  },
};
</script>



// WEBPACK FOOTER //
// resources/js/app/components/ClassicDisclaimer.vue